/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Question_6Inputs */

const en_help_center__bidding_n_battles__question_6 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Question_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are there any bidding strategies that work best?`)
};

/**
* | output |
* | --- |
* | "Are there any bidding strategies that work best?" |
*
* @param {Help_Center__Bidding_N_Battles__Question_6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__question_6 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Question_6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Question_6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__question_6(inputs)
});